import * as React from 'react'
import { Select } from './../../components/elements'
import "./../../style/dockerCompatibility.module.css"
import { getTechStackInfo, TechStackInfoResponse } from '../../api/techstack';
import { IMAGE_PATH_PREFIX } from "../../constants";
import { dockerVersionAvailablility, getLocationHref } from './../../utils'
const baseUrl = IMAGE_PATH_PREFIX + '/static/assets/docker-compatibility'
const readmeBaseUrl = 'https://github.com/supertokens/supertokens-docker'
type Props = {
};

type State = {
    loading: boolean,
    data: TechStackInfoResponse,
    error: boolean,
    superTokensSelectedVersion: string,
    databaseSelectedVersion: string,
    supportedPluginVersion: any,
    currentVersion: string,
    isSupported: boolean,
    copied: boolean,
    isPro: boolean,
    readmePath: string
}

export default class DockerCompatibility extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props)
        this.state = {
            loading: true,
            data: {
                cores: [],
                coreToDriver: {},
                coreToPlugin: {},
                drivers: [],
                plugins: [],
            },
            error: false,
            superTokensSelectedVersion: '',
            databaseSelectedVersion: '',
            supportedPluginVersion: {},
            currentVersion: '',
            isSupported: true,
            copied: true,
            isPro: false,
            readmePath: ''
        }
    }
    getSuperTokensVersionDropdown = () => {
        const coreVersionForSelect = this.state.data.cores.map(element => {
            return {
                id: element,
                displayName: element
            }
        })
        return (
            <div
                className="docker-compatibility-select-container">
                <div
                    className="compatibility-select-title">
                    SuperTokens Version
                </div>
                <Select
                    onSelected={this.onSuperTokenCoreVersionChange}
                    currentValue={this.state.superTokensSelectedVersion}
                    options={coreVersionForSelect}
                />
            </div>
        )
    }


    onSuperTokenCoreVersionChange = (event: React.FormEvent<HTMLSelectElement>) => {
        this.setState({ superTokensSelectedVersion: event.currentTarget.value })
    }

    onSuperTokenDatabaseVersionChange = (event: React.FormEvent<HTMLSelectElement>) => {
        this.setState({ databaseSelectedVersion: event.currentTarget.value })
    }

    changeCopiedState = (copyText: string) => {
        navigator.clipboard.writeText(copyText)
        this.setState({ copied: true })
        const that = this
        // changing copied after a second back to false if in case user wants to copy-again 
        setTimeout(function () {
            that.setState({ copied: false })
        }, 2000)
    }

    getSuperTokensDatabaseDropdown = () => {
        const databaseVersionToSelect = Object.keys(this.state.supportedPluginVersion).map(element => {
            return {
                id: this.state.supportedPluginVersion[element]["id"],
                displayName: this.state.supportedPluginVersion[element]["displayName"]
            }
        })
        return (
            <div
                className="docker-compatibility-select-container docker-compatibility-select-container-database">
                <div
                    className="compatibility-select-title">
                    Databases
                    </div>
                <Select
                    onSelected={this.onSuperTokenDatabaseVersionChange}
                    currentValue={this.state.databaseSelectedVersion}
                    options={databaseVersionToSelect}
                />
            </div>
        )
    }

    dockerCommandContainer = () => {
        if (this.state.databaseSelectedVersion === '' || this.state.superTokensSelectedVersion === '') {
            return
        }
        const docType = this.state.isPro ? 'pro' : 'community'

        const dockerDetails = dockerVersionAvailablility(this.state.superTokensSelectedVersion, docType, this.state.databaseSelectedVersion)
        // only non supported version here is 0.0 so if the current selected version is 0.0 (which should be last element in array)
        if (!dockerDetails.availability) {
            return (
                <>
                    <p className="readme-docs-error"> <img src={'/static/assets/warning-sign.png'} /> Docker image is not available for the selected SuperTokens version</p>
                </>
            )
        } else {
            return (
                <>
                    <div className="dockar-compatibility-command-container center-horizontally">
                        <div className="docker-compatibility-command-text">
                            <p> {dockerDetails.dockerCommand} </p>
                            <div onClick={() => this.changeCopiedState(dockerDetails.dockerCommand)} className="docker-compatibility-circular-icon-div center-horizontally">
                                <img src={`${baseUrl}/copy-icon.png`} className="docker-compatibility-image" />
                            </div>
                        </div>
                    </div>
                    <p className="readme-docs">View the <a href={dockerDetails.gitUrl} target="_blank"> README.md </a>  of this docker image</p>
                </>
            )
        }
    }



    componentDidMount() {
        this.fetchData()
    }
    fetchData = async () => {
        try {
            const isPro = getLocationHref().includes("/pro/");
            const techStackResponse = await getTechStackInfo(isPro ? "COMMERCIAL" : "FREE");
            let version: string = ''
            const supportedPluginVersion: { [key: string]: any } = {}
            const currentHref = window.location.href;
            const hrefSplit = currentHref.split("/");
            // Check if url contains version number
            if (hrefSplit.length === 6) {
                // URL does not have version number assume latest
                const versions = techStackResponse.cores;
                // backend sends latest version first
                version = versions[0];
            } else if (hrefSplit[5] === "next") {
                // URL has 'next' as version, assume latest
                let versions = techStackResponse.cores;
                // backend sends latest version first
                version = versions[0];
            } else {
                version = hrefSplit[5].replace(".X", "");
            }
            const allSuppertedCurrentPluginVersion = techStackResponse.coreToPlugin[version]
            if (allSuppertedCurrentPluginVersion !== undefined && Array.isArray(allSuppertedCurrentPluginVersion)) {
                for (let i = 0; i < allSuppertedCurrentPluginVersion.length; i++) {
                    const currentPluginId: string = allSuppertedCurrentPluginVersion[i]["id"]
                    supportedPluginVersion[currentPluginId] = allSuppertedCurrentPluginVersion[i]
                }
            }
            this.setState(oldState => ({
                ...oldState,
                loading: false,
                error: false,
                data: { ...techStackResponse },
                supportedPluginVersion: supportedPluginVersion,
                currentVersion: version,
                isPro: getLocationHref().includes("/pro/")
            }));
        } catch (e) {
            this.setState(oldState => ({
                ...oldState,
                loading: false,
                error: true,
            }));
        }
    }

    render() {
        if (this.state.loading) {
            return (
                <div
                    id="tech-stack-root">
                    <div
                        style={{
                            width: "100%",
                            height: "60vh",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}>
                        <div className="st-spinner" />
                    </div>
                </div>
            );
        } else {
            return (
                <div className="docker-compatibility-main">
                    <h1> Docker</h1>
                    {this.getSuperTokensVersionDropdown()}
                    {this.getSuperTokensDatabaseDropdown()}
                    {this.dockerCommandContainer()}
                </div>
            )
        }
    }
}


